import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { client } from "../../lib/config";
import { BedDouble, FileText, HelpCircle, Star, MessageSquare, Route, Calendar, Sparkles } from "lucide-react";

const CARDS = [
  { to: "/admin/rooms", label: "Rooms", endpoint: "/rooms", icon: BedDouble },
  { to: "/admin/blog", label: "Blog posts", endpoint: "/admin/blog-posts", icon: FileText },
  { to: "/admin/faqs", label: "FAQs", endpoint: "/faqs", icon: HelpCircle },
  { to: "/admin/testimonials", label: "Testimonials", endpoint: "/admin/testimonials", icon: Star },
  { to: "/admin/inquiries", label: "Inquiries", endpoint: "/inquiries", icon: MessageSquare },
  { to: "/admin/redirects", label: "Redirects", endpoint: "/redirects", icon: Route },
  { to: "/admin/events", label: "Events", endpoint: "/events", icon: Calendar },
  { to: "/admin/gbp", label: "GBP posts", endpoint: "/admin/gbp-posts", icon: Sparkles },
];

export default function AdminOverviewPage() {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    CARDS.forEach((c) => {
      client.get(c.endpoint).then((r) => {
        setCounts((prev) => ({ ...prev, [c.label]: Array.isArray(r.data) ? r.data.length : 0 }));
      }).catch(() => {});
    });
  }, []);

  return (
    <>
      <div className="mb-8">
        <div className="wb-eyebrow">Overview</div>
        <h1 className="wb-h2 mt-2">Welcome back.</h1>
        <p className="wb-body mt-2 max-w-2xl">Manage rooms, content, marketing, and the inquiries inbox from one place.</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {CARDS.map(({ to, label, icon: Icon }) => (
          <Link key={to} to={to} data-testid={`overview-card-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="wb-card bg-white p-6 hover:shadow-md hover:-translate-y-0.5 transition-[transform,box-shadow]">
            <div className="w-10 h-10 bg-[#FCEEEA] rounded-sm flex items-center justify-center mb-3">
              <Icon className="h-5 w-5 text-[#B94A15]" />
            </div>
            <div className="text-3xl font-black text-[#1A1A1A]" style={{ fontFamily: "'Nunito', sans-serif" }}>
              {counts[label] ?? "…"}
            </div>
            <div className="text-sm text-[#4A4641] mt-1">{label}</div>
          </Link>
        ))}
      </div>
    </>
  );
}
